// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"70":"2937f142","332":"7fd2d9c2","453":"3c2b4755","493":"f0ed1146","501":"ff0941b0","624":"5c9322ac","666":"d2c85ea8","753":"b0a2087b","834":"8345b69e","860":"51f9aa9f","867":"5c71b898","917":"03cf1617","965":"a2bfab40"}[chunkId] + ".chunk.js";
};